import { boot }    from "quasar/wrappers";
import { version } from '../../package.json'

export default boot(({ Vue }) => {
  window.APP_VERSION = version
});